import axios from "@/axios";

const articleApi = {
  items: '/api/pad/article/items',//知识列表
  complexItems: '/api/pad/article/complexItems',//复杂列表
  globalSearch: '/api/pad/article/globalSearch',//顶部搜索列表
  markRead: '/api/pad/article/markRead',//标记已读
  markAsRead:"/api/pad/message/markAsRead",//标记已读
  getHome:"/api/pad/index/getHome",
  myMessageList:"/api/pad/message/myMessageList",
  unreadCount:"/api/pad/message/unreadCount"
}

export function getUnreadCount(parameter) {
  return axios({
    url: articleApi.unreadCount,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
}
export function getMyMessageList(parameter) {
  return axios({
    url: articleApi.myMessageList,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
}

export function getHomeV(parameter) {
  return axios({
    url: articleApi.getHome,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
}

export function getItems(parameter) {
  return axios({
    url: articleApi.items,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
}

export function getComplexItems(parameter) {
  return axios({
    url: articleApi.complexItems,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
}

export function getGlobalSearch(parameter) {
  return axios({
    url: articleApi.globalSearch,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
} 

export function setMarkRead(parameter) {
  return axios({
    url: articleApi.markRead,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
}

export function setMarkAsRead(parameter) {
  return axios({
    url: articleApi.markAsRead,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
}